import clsx from 'clsx';
import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import styles from './styles.module.scss';

interface BriefingBodyProps {
  body: string;
  isSEOBot: boolean;
}

const Body = ({ body, isSEOBot }: BriefingBodyProps) => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.ContentBody,
  });

  useEffect(() => {
    const handleAnchorClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if the clicked element is an anchor tag
      if (target.nodeName === 'A') {
        trackEvent(
          click({
            clickLink: (target as HTMLAnchorElement).href,
            clickTarget: ClickTarget.AnchorLink,
            clickText: target.innerText,
          })
        );
      }
    };

    const briefingBody = document.querySelector('.briefing-body');
    briefingBody.addEventListener('click', handleAnchorClick);
    return () => {
      briefingBody.removeEventListener('click', handleAnchorClick);
    };
  }, [trackEvent]);

  return (
    <div
      className={clsx(styles.briefingBody, 'briefing-body font-noto-serif text-body-articles', {
        'seo-paywall-content': isSEOBot,
      })}
    >
      {ReactHtmlParser(body)}
    </div>
  );
};

export default Body;
